import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

import { Line } from '@/components/pages/ClientDevice/styles'

const AttendanceEmployeeByDayHeader = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader
        style={{ padding: 0 }}
        ghost={false}
        title={t('components.pages.attendanceEmployee.listReport.pageHeader.title')}
      />
      <Line />
    </>
  )
}

AttendanceEmployeeByDayHeader.displayName = 'AttendanceEmployeeByDayHeader'
export default AttendanceEmployeeByDayHeader
